// 直播相关请求
import req from './index'



//获取机场编号
export const getAirportNumber = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.GetRoutesInfo', params)
}

//获取直播地址
export const getLiveAddress = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.GetDockLiveStatus', params)
}
